import { Flex } from '@chakra-ui/react';
import React from 'react';

import { PortfolioSummaryChartContainer } from './PortfolioSummaryChartContainer';
import {
  Dashboard,
  PortfolioSummaryOverviewCards,
} from './PortfolioSummaryOverviewCards';
import { PortfolioSummaryAttributes } from 'packages/portfolio/ui/summary/PortfolioSummaryAttributes';

type PortfolioSummaryContainerProps = {
  capitalProviderOrganizationIds: string[];
  creditFacilityId: string;
  dashboard: Dashboard;
};
export const PortfolioSummaryContainer = ({
  capitalProviderOrganizationIds,
  creditFacilityId,
  dashboard,
}: PortfolioSummaryContainerProps) => {
  return (
    <Flex direction="column" gap="2.5rem">
      <PortfolioSummaryAttributes creditFacilityId={creditFacilityId} />
      <PortfolioSummaryOverviewCards
        capitalProviderOrganizationIds={capitalProviderOrganizationIds}
        creditFacilityId={creditFacilityId}
        dashboard={dashboard}
      />
      <PortfolioSummaryChartContainer creditFacilityId={creditFacilityId} />
    </Flex>
  );
};
